(function(window) {
    if (!(window.Ya && Ya.Rum)) {
        throw new Error('Rum: interface is not defined');
    }

    var rum = Ya.Rum;

    rum.getSetting = function(settingName) {
        var setting = rum._settings[settingName];

        return setting === null ? null : setting || '';
    };
})(typeof self !== 'undefined' ? self : window);
